namespace $.$$ {
	export class $shm_hitalama_map_widget_float_prompt extends $.$shm_hitalama_map_widget_float_prompt {
		
		prompt() {
			const values = this.widget().form_custom().object_current()
			return this.widget().text().replace( /\{\{([^}]+)\}\}/g, ( _, name )=> values[ name.trim() ] ?? '' )
		}
		
	}
}
